export enum RAGStatus {
  WAITING = 'WAITING',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
  FAILED = 'FAILED',
  NO_SUPPORTED_DOCUMENTS = 'NO_SUPPORTED_DOCUMENTS',
}
